export default __webpack_public_path__ + "72658b8e21123cdc7a3fc4e81e46489a.svg";